import * as React from 'react';

import { EngineRenderers } from '@websky/core/src/renderProps';
import BaggageIconBase from '@websky/core/src/Baggage/Baggage/components/BaggageIcon/BaggageIcon';

import { BaggageSize } from '@websky/core/src/Baggage/Baggage/types';
import { CarryOnSmall, LargeBaggageExcessIcon } from './icons';
import { BaggageType } from '@websky/graphql';

const IconsMap: React.ComponentProps<typeof BaggageIconBase>['iconsMap'] = new Map([
	[BaggageType.CarryOn, new Map([[BaggageSize.small, CarryOnSmall]])],
	[BaggageType.BaggageExcess, new Map([[BaggageSize.large, LargeBaggageExcessIcon]])]
]);

const BaggageIcon: EngineRenderers['BaggageIcon'] = props => {
	return <BaggageIconBase {...props} iconsMap={IconsMap} />;
};

export default BaggageIcon;
